import { useTranslation } from 'react-i18next'

import { ICON_HEIGHT_20, IconSpinner } from '../../Icon'
import Text from '../../Text'

import * as styles from './AIGretaLoader.module.css'

import SpinnerIcon from '../../../icons/spinner/spinner-ai-dark.svg'

function AIGretaLoader({
  className = styles.overlay,
  textKey = 'Wizard.AIWizardLoadingTextKey',
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <div className={styles.pill}>
        <IconSpinner Icon={SpinnerIcon} size={ICON_HEIGHT_20} />
        <Text className={styles.text}>{t(textKey)}</Text>
      </div>
    </div>
  )
}

export default AIGretaLoader
